import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { InfoFill24, InfoFill } from '../../icons';
import { Tooltip, Typography } from '../../index';
import styles from './WithStatusIcon.module.scss';
/**
 * Adds an error icon with info after the content. Used for decorating a text section
 * with an error icon.
 */ export function WithStatusIcon(props) {
    const { children, info, as, className, statusType = 'error', size = 'small', testId } = props, rest = _object_without_properties(props, [
        "children",
        "info",
        "as",
        "className",
        "statusType",
        "size",
        "testId"
    ]);
    const RootElement = as || 'div';
    return /*#__PURE__*/ _jsxs(RootElement, _object_spread_props(_object_spread({}, rest), {
        "data-testid": testId,
        className: cn(styles.root, className),
        children: [
            children,
            /*#__PURE__*/ _jsx(Tooltip, {
                placement: "top",
                title: info,
                children: /*#__PURE__*/ _jsxs(Typography, {
                    skin: statusType,
                    children: [
                        size === 'small' && /*#__PURE__*/ _jsx(InfoFill24, {}),
                        size === 'medium' && /*#__PURE__*/ _jsx(InfoFill, {})
                    ]
                })
            })
        ]
    }));
}
